import React from 'react'
import "./SeconedSection.css"
import { Col, Container, Row } from 'react-bootstrap'
import img1 from "../../Assets/images/image 3.png"
import img2 from "../../Assets/images/image 4.png"
import img3 from "../../Assets/images/image 7.png"
import img4 from "../../Assets/images/image 2.png"
import img5 from "../../Assets/images/image 5.png"
import img6 from "../../Assets/images/image 6.png"
import img7 from "../../Assets/images/Conversation Programs.png"
import img8 from "../../Assets/images/TeacherTrainingDiploma.png"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'


function SeconedSection() {

    const { t, i18n } = useTranslation();

    return (
        <div className='seconed-section my-5'>
            <Container>
                <h5 className='text-center'> {t("our_arabic_programs")} </h5>
                <p> {t("seven_learning_pathways")} </p>
                <div className='my-5 gx-4 cards-container'>

                    {/* <Col lg={2} md={6} sm={12}>
                        <div className='card card1 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img1} alt='' className='p-2' />
                            </div>
                            <Link to="/bareq" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("bareq")}</button>
                            </Link>
                        </div>
                    </Col> */}
                     {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card2 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img2} alt='' />
                            </div>
                            <Link to="/arabic-for-life" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("arabic_for_life")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                  
                    {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card3 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img3} alt=''  />
                            </div>
                            <Link to="/kalemon-k12" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("kalemon_k12")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                    {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card4 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img4} alt=''  />
                            </div>
                            <Link to="/arabic-specialized" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("arabic_specialized")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                    {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card5 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img5} alt=''  />
                            </div>
                            <Link to="/arabic-calligraphy" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("arabic_calligraphy")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                    {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card6 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img6} alt='' />
                            </div>
                            <Link to="/kalemon-levels" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("kalemon_levels")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                     {/* <Col lg={2} md={6} sm={12}> */}
                        <div className='card card7 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img7} alt=''  />
                            </div>
                            <Link to="/conversation-program" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("conversation_program")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                     {/* <Col lg    ={2} md={6} sm={12}> */}
                        <div className='card card8 mb-2'>
                            <div className='p-4 d-flex align-items-center justify-content-center'>
                                <img src={img8} alt=''  />
                            </div>
                            <Link to="/teachers" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                <button>{t("teacher_training_diploma")}</button>
                            </Link>
                        </div>
                    {/* </Col> */}
                </div>
                {/* <p> Bareq is an immersive digital platform designed to elevate your mastery of Modern Standard Arabic. Discover a world of interactive learning that empowers you to unlock your full potential in Arabic proficiency </p> */}

                <div className='last-sec my-5'>
                    <Link to="/all-programs" onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); }}>
                        <button > {t("discover_the_program")} </button>
                    </Link>
                </div>

            </Container>

        </div>
    )
}

export default SeconedSection
